import  * as React from "react";  import { observer } from "mobx-react";
import { IInstructorMessageProps } from "./IInstructorMessageProps";
import { IInstructorMessageState} from "./IInstructorMessageState";


@observer
export class InstructorMessage extends React.Component<IInstructorMessageProps, IInstructorMessageState> {
    constructor(props: IInstructorMessageProps) {
        super(props);
        this.handleMessageChange = this.handleMessageChange.bind(this);

        var msg = this.unhtmlify(props.instructorMessage);

        this.state = {
            value: msg,
            htmlValue: this.htmlify(msg)
        };
    }

    private unhtmlify(input: string): string {
        return input.replace(/<br ?\/?>/g, "\n");
    }

    private htmlify(input: string): string {
        return input.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }

    private handleMessageChange(event: any) {
        this.setState({ value: event.target.value, htmlValue: this.htmlify(event.target.value) }, () => {
            if(this.props.onInstructorMessageChanged){
                this.props.onInstructorMessageChanged(this.state.value, this.state.htmlValue);
            }
        });

    }

    render() {

        let webInstructorEntire = <div>
            <p className="display-instructor-message">
                {this.unhtmlify(this.props.instructorMessage).split('\n').map((item, key) => {
                    return <span key={key}>{item}<br /></span>
                })}
            </p>
            <p className="instructor-name">{this.props.instructorName}</p>
        </div>;

        let tpsInstructorEntire = <div>
            <form>
                <textarea className="instructor-message-textarea" value={this.state.value || this.props.instructorMessage} onChange={this.handleMessageChange}>
                </textarea>
            </form>
            <p className="instructor-name"> {this.props.instructorName}</p>
        </div>;

        return <div className="instructor-message-wrapper">
            {this.props.isTps && !this.props.isPrint ? tpsInstructorEntire : webInstructorEntire}
        </div>;
    }
}
